import { all, call, takeLatest } from 'redux-saga/effects';
import { deleteViolation, getViolations } from 'api/violation';
import { VIOLATION_ACTION_TYPES } from '../actions/violation.actions';

function* loadViolations(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getViolations, payload);
    resolve({
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteViolationFlow({ payload, resolve, reject }) {
  try {
    yield call(deleteViolation, payload);
    yield call(resolve);
  } catch (e) {
    yield call(reject, e.response.data);
  }
}

export default function* () {
  yield all([
    takeLatest(VIOLATION_ACTION_TYPES.LOAD_VIOLATIONS, loadViolations),
    takeLatest(VIOLATION_ACTION_TYPES.DELETE_VIOLATION, deleteViolationFlow),
  ]);
}